export default __webpack_public_path__ + "static/media/jupi1.35afed02.png";